// this synchronously generates a hash that's good enough for pseudonymization
function fnv1aHash(str: string): number {
  let hash = 0x811c9dc5; // FNV offset basis
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193); // FNV prime
  }
  return hash >>> 0; // Unsigned 32-bit integer
}

export function pseudonymize(username: string, salt = 'weave-username-v1::'): string {
  const salted = salt + username;
  const hash = fnv1aHash(salted);
  return hash.toString(16); // Hex output
}
